import { createThemeCompiler } from '../../../utils';

export const menuThemeCompiler = createThemeCompiler(({ palette, borderRadius, stroke }) => ({
    menu: {
        collapsibleMenu: {
            colors: {
                backgroundColor: palette.white,
                borderColor: palette.neutralQuaternary,
                item: {
                    default: {
                        backgroundColor: palette.transparent,
                        borderColor: palette.transparent,
                        mainIcon: '#c2c5ca',
                        menuIcon: palette.neutralPrimary,
                        text: palette.neutralPrimary
                    },
                    expanded: {
                        backgroundColor: palette.transparent,
                        borderColor: palette.transparent,
                        mainIcon: '#c2c5ca',
                        menuIcon: palette.neutralPrimary,
                        text: palette.themePrimary
                    },
                    hovered: {
                        backgroundColor: palette.transparent,
                        borderColor: palette.transparent,
                        mainIcon: palette.themePrimary,
                        menuIcon: palette.neutralSecondary,
                        text: palette.themePrimary
                    },
                    selected: {
                        backgroundColor: palette.themePrimary,
                        borderColor: palette.themePrimary,
                        mainIcon: palette.white,
                        menuIcon: palette.white,
                        text: palette.white
                    }
                }
            },
            composites: {
                borderWidth: {
                    item: stroke.none,
                    root: stroke.thin
                },
                borderRadius: {
                    item: borderRadius.curvedSmall,
                    root: borderRadius.curvedSmall
                }
            }
        },
        flyoutMenu: {
            colors: {
                backgroundColor: palette.white,
                borderColor: palette.neutralLight,
                item: {
                    default: {
                        backgroundColor: palette.transparent,
                        borderColor: palette.transparent,
                        mainIcon: '#667287',
                        menuIcon: palette.neutralPrimary,
                        text: '#676E7B'
                    },
                    expanded: {
                        backgroundColor: palette.transparent,
                        borderColor: palette.transparent,
                        mainIcon: palette.themeLight,
                        menuIcon: palette.neutralPrimary,
                        text: palette.themeLight
                    },
                    hovered: {
                        backgroundColor: palette.neutralLight,
                        borderColor: palette.neutralLight,
                        mainIcon: '#667287',
                        menuIcon: palette.neutralPrimary,
                        text: palette.neutralPrimary
                    },
                    selected: {
                        backgroundColor: palette.themePrimary,
                        borderColor: palette.themePrimary,
                        mainIcon: palette.white,
                        menuIcon: palette.white,
                        text: palette.white
                    }
                }
            },
            composites: {
                borderWidth: {
                    item: stroke.none,
                    root: stroke.thin
                },
                borderRadius: {
                    item: borderRadius.curvedSmall,
                    root: borderRadius.curvedSmall
                }
            }
        },
        replaceMenu: {
            colors: {
                backgroundColor: palette.white,
                borderColor: palette.neutralLight,
                item: {
                    default: {
                        backgroundColor: palette.transparent,
                        borderColor: palette.transparent,
                        mainIcon: '#667287',
                        menuIcon: palette.neutralPrimary,
                        text: '#676E7B'
                    },
                    expanded: {
                        backgroundColor: palette.transparent,
                        borderColor: palette.transparent,
                        mainIcon: palette.themeLight,
                        menuIcon: palette.neutralPrimary,
                        text: palette.themeLight
                    },
                    hovered: {
                        backgroundColor: palette.neutralLight,
                        borderColor: palette.neutralLight,
                        mainIcon: '#667287',
                        menuIcon: palette.neutralPrimary,
                        text: palette.neutralPrimary
                    },
                    selected: {
                        backgroundColor: palette.themePrimary,
                        borderColor: palette.themePrimary,
                        mainIcon: palette.white,
                        menuIcon: palette.white,
                        text: palette.white
                    }
                },
                backButton: {
                    backgroundColor: palette.themePrimary,
                    foregroundColor: palette.themePrimary,
                    iconColor: palette.white
                }
            },
            composites: {
                borderWidth: {
                    item: stroke.none,
                    root: stroke.thin
                },
                borderRadius: {
                    item: borderRadius.curvedSmall,
                    root: borderRadius.curvedSmall
                },
                backIconBorderRadius: borderRadius.circle
            }
        }
    }
}));
